// ─────────────────────────────────────────────────────────────────────────────
// 🔑 THE DOWN-PAYMENT ESTIMATE, IN THE BORROWER'S AND THE PARTNER'S WORDS (Jesse, 2026-10-29 — the approved mockups +
// the FINAL tweaks). One file for the copy so the screens and the tests read the same sentences:
//   • step 2 (steps 1–3): the "Est. Min. Required" label, the estimate card, the green line;
//   • step 5: the verified / estimate card (single, joint, and planned == minimum);
//   • step 8: the planned/minimum rows beside "View your notice" (the line itself is the server's — backend
//     utils/downPaymentEstimate.step8DownPaymentLine);
//   • the DoorlyPro LO form: the "Estimate…" note.
// The minimum on step 5 is the STORED minimum (backend utils/downPaymentEstimate.estimatedMinimumOf).
// ─────────────────────────────────────────────────────────────────────────────

const money = (n) => `$${Math.round(Number(n) || 0).toLocaleString('en-US')}`;

export const STEP2_MIN_LABEL = 'Est. Min. Required';
export const STEP2_ESTIMATE_NOTE = 'These are estimates. Your final minimum down payment, loan amount and LTV are set once we’ve reviewed your credit and income, and may go up or down.';
/** The green line on step 2: "Down payment meets the estimated 10% minimum." */
export const step2MeetsLine = (pctLabel) => `Down payment meets the estimated ${pctLabel} minimum.`;

const CONFIRM = 'We’ll confirm it on step 8, and it may go up or down.';
// 🔑 STEP 5'S VERIFIED / ESTIMATE CARD (Jesse, 2026-10-30 — supersedes the one-paragraph form): the step-2 estimate card's
// style, two lines.
//   Line 1 (amount bold): single "$60,000 verified toward the $40,000 down payment you planned."
//                         joint  "You and Chris have $60,000 verified toward the $40,000 down payment you planned."
//   Line 2 (smaller):     "Estimated minimum: $30,000 (10%). We'll confirm it on step 8, and it may go up or down."
//                         planned == minimum: "That's the estimated minimum (10%). We'll confirm it on step 8, and it may go up or down."
/** Line 1's lead before the bold amount: '' on a solo file, "You and Chris have " on a joint one (whoHas). */
export const step5CardLead = (who) => (who && who !== 'You have' ? `${who} ` : '');
/** Line 1 after the bold amount. */
export const step5CardAfter = (planned) => (Number(planned) > 0
  ? ` verified toward the ${money(planned)} down payment you planned.` : ' verified.');
/**
 * Line 2, or null when no estimate is known (or nothing was planned).
 * @param {{planned:number, minimum:{amount:number, pct:number}|null}} o
 */
export function step5CardEstimate({ planned, minimum }) {
  const m = minimum && Number(minimum.amount) > 0 && Number(minimum.pct) > 0 ? minimum : null;
  if (!m || !(Number(planned) > 0)) return null;
  if (Math.round(Number(planned)) === Math.round(Number(m.amount))) return `That’s the estimated minimum (${m.pct}%). ${CONFIRM}`;
  return `Estimated minimum: ${money(m.amount)} (${m.pct}%). ${CONFIRM}`;
}
/** The card as plain text: { line1, line2 } (who = "You have" | "You and Chris have"). */
export function step5CardText({ who = 'You have', verified, planned, minimum = null }) {
  return { line1: `${step5CardLead(who)}${money(verified)}${step5CardAfter(planned)}`, line2: step5CardEstimate({ planned, minimum }) };
}

/** Step 8, the counteroffer on terms: the two rows beside "View your notice". */
export const STEP8_TERMS_ROWS = Object.freeze({ planned: 'You planned a down payment of', minimum: 'Your minimum down payment is' });
export const step8TermsFigure = (f) => `${money(f.amount)} (${f.pct}%)`;

/** DoorlyPro LO form, under the server's minimum line. */
export const LO_ESTIMATE_NOTE = 'Estimate. The final down payment is set at the decision and may differ.';
